import moment from 'moment-timezone'
import type { TSplineSeriesData } from '../../types'
import { getBlankSeriesInterval } from './getBlankSeriesInterval'

export const createBlankSeries = ({
  dateFrom,
  dateTo,
  timezone,
  defaultY,
}: {
  dateFrom: string | number
  dateTo: string | number
  timezone: string
  defaultY: number
}): TSplineSeriesData[] => {
  const startTimestamp = moment.tz(dateFrom, timezone).valueOf()
  const endTimestamp = moment.tz(dateTo, timezone).valueOf()
  const interval = getBlankSeriesInterval()

  return Array.from({ length: Math.ceil((endTimestamp - startTimestamp) / interval) + 1 }, (_, index) => ({
    x: startTimestamp + index * interval,
    y: defaultY,
  }))
}
